import { FC, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { HStack, Stack } from '@chakra-ui/react';
import { IconName } from '@shinetools/sunshine-icons';

import Chip from 'components/_core/Chip';
import Heading from 'components/_core/Heading';
import TrackView from 'features/Analytics/TrackView';

import { CompanyInformation } from '../../types';
import GeneralInformation from './components/GeneralInformation';
import InvoicingInformation from './components/InvoicingInformation';
import locales from './locales';

const COMPANY_TABS: { key: CompanyInformation; icon: IconName }[] = [
  { icon: 'company', key: 'general' },
  { icon: 'invoice', key: 'invoicing' },
];

const CompanyProfile: FC = () => {
  const { hash: currentHash } = useLocation();
  const { push } = useHistory();

  useEffect(() => {
    if (!currentHash) {
      // @ts-expect-error Object is possibly 'undefined'.
      push(`#${COMPANY_TABS[0].key}`);
    }
  }, [currentHash, push]);

  return (
    <Stack alignItems="flex-start" spacing="space-40">
      <TrackView pageName="CompanyProfile" />

      <Heading size="lg">{locales.myCompany}</Heading>

      <HStack spacing="space-8">
        {COMPANY_TABS.map(({ icon, key }) => (
          <Chip
            icon={icon}
            isActive={location.hash.includes(key)}
            key={key}
            onClick={() => push(`#${key}`)}
          >
            {locales.tabs[key]}
          </Chip>
        ))}
      </HStack>

      {currentHash.includes('general') ? <GeneralInformation /> : null}

      {currentHash.includes('invoicing') ? <InvoicingInformation /> : null}
    </Stack>
  );
};

export default CompanyProfile;
